import { render, staticRenderFns } from "./Responsive.vue?vue&type=template&id=173a3510&"
import script from "./Responsive.vue?vue&type=script&lang=js&"
export * from "./Responsive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports